import { Component, OnInit, EventEmitter, Input, Output, NgZone, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { CommonService } from '../services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.page.html',
  styleUrls: ['./faqs.page.scss'],
})
export class FaqsPage implements OnInit {
  @ViewChild("focusAlert") focusAlert: ElementRef;

  isShow: boolean = false;
  isShowQuestion: boolean = false;
  searchText: any = ''
  showPage: boolean = false
  state: any = ''
  faqList: any = [];
  categoryList: Array<any> = [];
  faqSubscription: Subscription;
  toggleRows: boolean  = false;
  categoryId:string;
  faqId:string;

  remarks: string = '';
  @Input() rating: number = 0;

  @Output() ratingChange: EventEmitter<number> = new EventEmitter();
  AllCategory: any = [{
    "CategoryId": '1',
    "Description": "Category 1"
  },
  {
    "CategoryId": '2',
    "Description": "Category 2"
  }]

  constructor(private formBuilder: FormBuilder, private ngZone: NgZone, public ngxSmartModalService: NgxSmartModalService, private location: Location, private _apiService: ApiService, public _commonService: CommonService, private route: ActivatedRoute, private router: Router) {

    const navigation = this.router.getCurrentNavigation();

    if (navigation && navigation.extras.state) {
      this.state = navigation.extras.state.faq
    }

  }


  ngOnInit() {
  }

  toggle(catId, status) {
    if (status == 'show') {
      this.categoryList.forEach(async (element) => {
        if (element.CategoryId == catId) {
          element.showQuestion = 'true';
          element.expand = 'true'
        }
      });
    } else if (status == 'hide') {
      this.categoryList.forEach(async (element) => {
        if (element.CategoryId == catId) {
          element.showQuestion = 'false';
          element.expand = 'false';
        }
      });
    }

    // this.isShow = ! this.isShow
  }
  toggleQuestion(faqId, status) {
    this.categoryList.forEach(element => {
      if (element.Faq.length > 0) {
        element.Faq.forEach(data => {
          if (data.FaqId == faqId) {
            if (data.expand == 'true') {
              data.expand = 'false';
            } else {
              data.expand = 'true';
            }

          }
        })
      };
    });

  }

  toggleRow(catId){
    this.categoryList.forEach(async (element) => {
      if (element.CategoryId == catId) {
        if(element.expand == 'false'){
          element.showQuestion = 'true';
          element.expand = 'true'
        }else if(element.expand == 'true'){
          element.showQuestion = 'false';
          element.expand = 'false'
        }
      }
    });
  }


  ionViewDidEnter() {
    this.showPage = false
    this.toggleRows = false
    this.categoryId = this.route.snapshot.paramMap.get('id');
    this.faqId = this.route.snapshot.paramMap.get('faqId');
    this.getFaqDetail();
  }

  ionViewDidLeave() {

  }

  async getFaqDetail() {
    try {
      this._commonService.presentLoading()
      let res = await this._apiService.getClientFaqs(this.searchText ? this.searchText : '');
      this.categoryList = res.body;
      let staticQuestion = {
        CategoryDescription: this._commonService.getLocalTranslation('label-faqCatagoryOnboarding'),
        showClickHere : true,
        Faq : [{
          Answer: this._commonService.getLocalTranslation('label-faqAnswerOnboarding'),
          FaqId: "staticId",
          Question: this._commonService.getLocalTranslation('label-faqQuestionOnboarding'),
        }]
      }
      this.categoryList.push(staticQuestion);
      this.categoryList.forEach(async (element) => {
        element.expand = 'false'
        if (element.Faq.length > 0) {
          element.Faq.forEach(data => {
            data.expand = 'false';
          })
        };
      });
      if (this.state) {

        this.categoryList.forEach(element => {

          if (element.CategoryId == this.state.CategoryId) {
            element.expand = 'true';
            element.showQuestion = 'true';
            if (element.Faq.length > 0) {
              element.Faq.forEach(data => {
                if (data.FaqId == this.state.FaqId) {
                  data.expand = 'true';

                }

              })
            };
          }
        });
      }else{
        if( this.categoryId!='0' && this.categoryId!=null && this.categoryId!=undefined ){
          this.categoryList.forEach(element => {

            if (element.CategoryId == this.categoryId) {
              element.expand = 'true';
              element.showQuestion = 'true';
              if (element.Faq.length > 0) {
                element.Faq.forEach(data => {
                  if (data.FaqId == this.faqId) {
                    data.expand = 'true';

                  }

                })
              };
            }
          });
        }
      }
      // this.faqList = res.body
      this.showPage = true;
      if (this.state) {
        setTimeout(() => {
          let expandedClass = document.getElementsByClassName('expanded');
          expandedClass[0].scrollIntoView({ behavior: "smooth", block: "center" })
        }, 0);
      }else{
        if( this.categoryId!='0' && this.categoryId!=null && this.categoryId!=undefined ){
          setTimeout(() => {
            let expandedClass = document.getElementsByClassName('expanded');
            expandedClass[0].scrollIntoView({ behavior: "smooth", block: "center" })
          }, 0);
        }
      }
      this._commonService.dismiss()
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  openRatingModal(row) {
    this.rating = 0;
    this.remarks = ''
    this.ngxSmartModalService.getModal('FaqRatingModal').open()
    setTimeout(() => {
      this.focusAlert.nativeElement.focus();
      document.getElementById('alertFocus').classList.add("rating-alert-button");
    }, 100);
  }

  rate(index: number) {
    this.rating = index;
    this.ratingChange.emit(this.rating);
  }

  getColor(index: number) {
    if (index) {
      if (this.isAboveRating(index)) {
        return "../assets/star_favorite.svg";
      } else {
        return "../assets/star_favorite_fill.svg";
      }
    } else {
      return "../assets/star_favorite.svg";
    }

  }

  isAboveRating(index: number): boolean {
    return index > this.rating;
  }

  async RateAndCloseModal() {
    this.ngxSmartModalService.getModal('FaqRatingModal').close();
    try {
      this._commonService.presentLoading();
      let data = {
        "ModuleId": "c32ac47e-a8e0-4eca-b309-6d2378b0bce2",
        "UserRating": this.rating ? this.rating : null,
        "UserRemark": this.remarks ? this.remarks : null,
        "ExternalRefId": null
      }
      let res = await this._apiService.postUserRatings(data);
      if (res.id) {

      }
      this._commonService.dismiss();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-feedbackGiven'));
      this._commonService.log(data, this._commonService.LOG);
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }

  }

  async closeRatingModal() {
    this.ngxSmartModalService.getModal('FaqRatingModal').close();
  }

  onActionChange(faq) {
    if (faq) {
      this.state = faq
      this.categoryList.forEach(element => {
        element.expand = 'false';
        element.showQuestion = 'false';
        if (element.Faq.length > 0) {
          element.Faq.forEach(data => {
            data.expand = 'false';
          })
        };
      });
      this.categoryList.forEach(element => {
        if (element.CategoryId == this.state.CategoryId) {
          element.expand = 'true';
          element.showQuestion = 'true';
          if (element.Faq.length > 0) {
            element.Faq.forEach(data => {
              if (data.FaqId == this.state.FaqId) {
                data.expand = 'true';
              }
            })
          };
        }
      });
      setTimeout(() => {
        let expandedClass = document.getElementsByClassName('expanded');
        expandedClass[0].scrollIntoView({ behavior: "smooth", block: "center" })
      }, 0);
    } else {
      this.state = ''
    }
  }

  goToDashboard() {
    localStorage.setItem('FaqOnboarding','true');
    this.router.navigate(['/dashboard']);
  }
}
